import { DescribeAssetCommand, GetAssetPropertyValueCommand, DescribeAssetModelCommand, ListAssetsCommand, ListAssociatedAssetsCommand, } from '@aws-sdk/client-iotsitewise';
import { DescribeModeledDataStreamRequest } from './describeModeledDataStreamRequest/describeModeledDataStreamRequest';
export const createSiteWiseAssetDataSource = (api) => {
    const describeModeledDataStreamRequest = new DescribeModeledDataStreamRequest(api);
    return {
        describeAsset: (input) => {
            return api.send(new DescribeAssetCommand(input));
        },
        getPropertyValue: (input) => {
            return api.send(new GetAssetPropertyValueCommand(input));
        },
        describeAssetModel: (input) => {
            return api.send(new DescribeAssetModelCommand(input));
        },
        listAssets: (input) => {
            return api.send(new ListAssetsCommand(input));
        },
        listAssociatedAssets: (input) => {
            return api.send(new ListAssociatedAssetsCommand(input));
        },
        describeModeledDataStream: (input) => {
            return describeModeledDataStreamRequest.send(input);
        },
    };
};
